// Autobahn (auto.de redesign) — Checkout Step 4b (Lieferung), md3 re-skin.
//
// Drop-in md3 replacement for DeliveryServices (variant='next'). Same store handler
// (handleChangeStoreValue 'withTransportation') + the same "different delivery address" modal.
// Only the fe-ui-core RadioGroup/ServiceCardWrapper markup is re-skinned to md3 cards.
import * as React from 'react';
import { useObserver } from 'mobx-react-lite';
import { Icon } from '@bytebrand/fe-ui-core-autobahn/ui';
const fmtEur = (n) => (n || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const DeliveryServicesNext = ({ deliveryAddresses, setDeliveryAddressesProfile, setDeliveryCheckoutAddressObj, t, showModal, withTransportation, transportationCost, selectedDeiveryAddressValue, handleChangeStoreValue, }) => {
    React.useEffect(() => {
        if (deliveryAddresses) {
            deliveryAddresses.forEach((item) => {
                const addr = { firstName: item.firstName, lastName: item.lastName, street: item.street, number: item.number, zip: item.zip, city: item.city };
                setDeliveryAddressesProfile(`${item.firstName} ${item.lastName} ${item.street} ${item.number}, ${item.zip} ${item.city}`);
                setDeliveryCheckoutAddressObj(addr);
            });
        }
        window.scrollTo(0, 0);
    }, []);
    const deliveryServices = t('additionalServices.deliveryServices', { returnObjects: true });
    return useObserver(() => (React.createElement("div", { className: "co-form" },
        React.createElement("h2", { className: "co-step-title" }, t('CheckoutPage:additionalServices.pagetitle')),
        React.createElement("p", { className: "co-step-sub" }, t('CheckoutPage:additionalServices.longtitle')),
        React.createElement("section", { className: "co-card" },
            React.createElement("h3", { className: "co-card-title" },
                React.createElement(Icon, { name: "truck", size: 18, cls: "co-card-ic" }),
                t('CheckoutPage:orderOverview.vehicleDelivery')),
            React.createElement("div", { className: "co-pay-grid" }, (Array.isArray(deliveryServices) ? deliveryServices : []).map(({ name, content }, index) => {
                const isDelivery = index === 0;
                const selected = withTransportation === isDelivery;
                return (React.createElement("button", { key: index, type: "button", role: "radio", "aria-checked": selected, className: 'co-pay-card' + (selected ? ' is-on' : ''), onClick: () => handleChangeStoreValue({}, isDelivery, 'withTransportation') },
                    React.createElement("span", { className: "co-pay-radio" }),
                    React.createElement(Icon, { name: isDelivery ? 'truck' : 'map-pin', size: 24 }),
                    React.createElement("span", { className: "co-pay-label" }, name),
                    content ? React.createElement("span", { className: "co-pay-info" }, content) : null,
                    React.createElement("span", { className: "co-pay-price" }, isDelivery ? `${fmtEur(transportationCost)} €` : `0,00 €`),
                    isDelivery && selectedDeiveryAddressValue ? React.createElement("span", { className: "co-pay-info" }, selectedDeiveryAddressValue) : null,
                    isDelivery ? (React.createElement("span", { className: "co-addr-link", onClick: (e) => { e.stopPropagation(); showModal('DELIVERY_ADDRESSES_MODAL', { t }); } },
                        React.createElement(Icon, { name: "plus", size: 15 }),
                        t('CheckoutPage:differentDeliveryAddress'))) : null));
            }))))));
};
export default DeliveryServicesNext;
